import { useState } from 'react';
import MedicineSearch from './MedicineSearch';
import MedicineList from './MedicineList';
import MedicineProvider from 'hooks/Medicine';

const Medicine = () => {
  const medicinesState = useState<Medicine[]>([]);
  const medicinesStatusState = useState<LoadingStatus>('NOT_LOADED');

  return (
    <MedicineProvider>
      <MedicineSearch
        medicinesState={medicinesState}
        fetchStatusState={medicinesStatusState}
      />
      <MedicineList
        medicines={medicinesState[0]}
        fetchStatus={medicinesStatusState[0]}
      />
    </MedicineProvider>
  );
};

export default Medicine;
